/**
 * Текст сообщения в уведомлении, которое рисует живое приложение (аудит 2026-10-17, PRIV-5).
 *
 * <p>Пуш собирает сервер и сам выбрасывает текст, если человек попросил его не показывать. Но
 * пока приложение живо, уведомление о сообщении из сокета рисуется здесь — и без этой проверки
 * текст, который спрятан в пушах, всё равно ложился бы на экран блокировки.
 *
 * @returns {@code undefined} — тогда уведомление покажет общее «Новое сообщение».
 */
export function localNotificationBody(
  showMessageText: boolean | undefined,
  preview: string | undefined,
): string | undefined {
  // Поле не пришло (сервер постарше) — текст виден, как и было.
  return showMessageText === false ? undefined : preview;
}
